<template>
    <div>
        <hts-form-autocomplete
            v-model="vehicleCategoryId"
            :label="$t('labels.vehicleModule.category.find')"
            :required="props.required"
            :server="serverVehicleCategory"
            :text="vehicleCategoryName"
            :placeholder="$t('labels.vehicleModule.category.select')"
            :add="false"
            key-id="_id"
            key-label="name"
            :vehicle-load="vehicleLoadData"
            @change="(data:any, dataDetail: any)=>handleChange(data, dataDetail)" />
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  required: {
    type: Boolean,
    default: true
  },
  vehicleCategoryIsSelected: {
    type: Object,
    default: () => {}
  },
  vehicleLoad: {
    type: Number,
    default: 0
  }
})
const vehicleCategoryId = ref('')
const vehicleCategoryName = ref('')
const serverVehicleCategory = $urlAdmin.vehicle.category.find
const emits = defineEmits(['changeInput'])
const vehicleLoadData = ref()
watch(props, () => {
  if (props.vehicleCategoryIsSelected) {
    vehicleCategoryName.value = props.vehicleCategoryIsSelected.name
  } else {
    vehicleCategoryName.value = ''
  }
  vehicleLoadData.value = props.vehicleLoad
})
const handleChange = (data: any, dataDetail: any) => {
  emits('changeInput', data, dataDetail)
}
</script>
